import { render, staticRenderFns } from "./teamDetail2info.vue?vue&type=template&id=6d381e35&scoped=true&"
import script from "./teamDetail2info.vue?vue&type=script&lang=js&"
export * from "./teamDetail2info.vue?vue&type=script&lang=js&"
import style0 from "./teamDetail2info.vue?vue&type=style&index=0&id=6d381e35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d381e35",
  null
  
)

export default component.exports